// extracted by mini-css-extract-plugin
export default {"container":"Input_container__LwTub","slideUp":"Input_slideUp__T9ycT","icon":"Input_icon__U7UwM"};